import {Mitarbeiter} from './mitarbeiter';
import {TemostaDataListValidationDto} from './temosta-data-list-validation-dto';

export class FunctionBknBstGrouped {
  functionName: string;
  // bkn: string;
  // bst: string;
  bkn: number;
  bst: number;
  fnValidator: TemostaDataListValidationDto[];
  mitarbeiters: Mitarbeiter[];
  isEditable: boolean;
  constructor(funktion: string, isEditable: boolean) {
    this.functionName = funktion;
    this.isEditable = isEditable;
    this.mitarbeiters = [];
    this.fnValidator = [];
  }
}

export enum FunctionBknBstGroupedProperties {
  funktion = 0,
  bkn = 1,
  bst = 2
}
